import cn from "classnames"
import React from "react"
import { useTranslation } from "react-i18next"

import { Heading } from "~/components/Heading/Heading"
import { Raw } from "~/components/raw"
import { Subscription as CommonSubscription } from "~/components/Subscription/Subscription"

import styles from "./index.module.css"

type Props = {
  code?: string
  title?: string
  inContactForm?: boolean
  categoriesList?: { id: string; code: string; name: string }[]
  returnValuesType?: "id" | "code" | "name"
}

export const Subscription: React.FC<Props> = ({
  code,
  title,
  inContactForm,
  categoriesList,
  returnValuesType,
}) => {
  const { t } = useTranslation()

  return (
    <>
      {title && (
        <Heading className={styles.Title} like="h2">
          <Raw html={title} />
        </Heading>
      )}

      <CommonSubscription
        categoriesList={categoriesList}
        classNameBottomWrapper={cn(
          !inContactForm ? styles.BottomWrapperCommon : styles.BottomWrapper,
        )}
        code={code}
        returnValuesType={returnValuesType}
      />
    </>
  )
}
